var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDonateKing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 19.7143L7.42857 14L12 16.2857L8.57143 22L7.42857 19.7143H4Z",
    fill: "#B8C8DD",
    stroke: "#4E6090",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 19.7143L17.5714 14L13 16.2857L16.4286 22L17.5714 19.7143H21Z",
    fill: "#B8C8DD",
    stroke: "#4E6090",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.6C14.495 16.6 15.9848 15.7443 17.2385 14.5132C17.3544 14.3993 17.4746 14.287 17.5965 14.1731C18.1639 13.6428 18.7678 13.0784 19.1475 12.1686C19.4419 11.463 19.6 10.3522 19.6 9.61685C19.6 7.72338 18.8752 5.68634 17.5642 4.39887C16.8823 3.72925 16.0263 3.31821 15.0807 3.03653C14.1398 2.75629 13.0724 2.59368 11.9462 2.44577C10.6643 2.27741 9.74218 2.5895 8.98697 3.12512C8.62374 3.38274 8.30894 3.68481 8.02196 3.98026C7.90337 4.10234 7.7944 4.2179 7.68826 4.33046C7.52276 4.50597 7.36413 4.67419 7.18664 4.84849C5.86244 6.14889 5.4 7.7463 5.4 9.61685C5.4 10.4547 5.62161 11.837 5.83301 12.5209L6.40355 12.3446L5.83301 12.5209C5.97995 12.9963 6.15869 13.2961 6.41766 13.5682C6.52866 13.6849 6.65126 13.7928 6.76639 13.8942L6.77979 13.906C6.90343 14.015 7.03468 14.1309 7.18664 14.2801C8.44671 15.5175 10.5121 16.6 12.5 16.6Z",
    fill: "url(#paint0_linear_11066_19680)",
    stroke: "#99591E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5348 12.0748C11.2318 12.0807 11.4294 11.575 11.6873 10.9219C11.8373 10.5423 12.1961 10.1128 12.1926 9.70519C12.1833 8.59616 11.1933 8.27797 10.2121 7.96658C9.23092 7.65519 8.00382 8.14763 8.0315 9.29575C8.0443 9.82693 7.78386 10.5277 8.64045 11.3281C9.08213 11.7408 10.4876 12.0744 10.5348 12.0748Z",
    fill: "#8B572A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1682 9.90625C15.8136 9.90625 16.2596 10.1945 16.459 10.7406C16.6585 11.2867 16.5908 11.7531 16.0687 12.0906C15.5465 12.4281 14.6284 12.4281 14.1062 12.0906C13.5841 11.7531 13.6779 11.2867 13.8773 10.7406C14.0768 10.1945 14.5228 9.90625 15.1682 9.90625Z",
    fill: "#8B572A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.399 5.04288C13.7995 5.04288 14.0762 5.22591 14.1999 5.57264C14.3237 5.91937 14.4488 6.23888 14.1248 6.45317C13.8008 6.66746 13.5154 7.06254 12.7029 6.65629C12.0563 6.27341 12.3213 5.79445 12.4997 5.43753C12.7028 5.03128 12.9985 5.04288 13.399 5.04288Z",
    fill: "#8B572A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11066_19680",
    x1: 12.5,
    y1: 3,
    x2: 12.5,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC37A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBAD61"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDonateKing);
export default __webpack_public_path__ + "static/media/ic_donate_king.b1e60a0bfa0579255765dbd441616f1b.svg";
export { ForwardRef as ReactComponent };